__turbopack_context__.v({
  "atc": "AddToCartButton-module-scss-module__FysyBG__atc",
  "atc--full": "AddToCartButton-module-scss-module__FysyBG__atc--full",
  "atc__btn": "AddToCartButton-module-scss-module__FysyBG__atc__btn",
  "atc__btn_lg": "AddToCartButton-module-scss-module__FysyBG__atc__btn_lg",
  "atc__error": "AddToCartButton-module-scss-module__FysyBG__atc__error",
  "atc__hint": "AddToCartButton-module-scss-module__FysyBG__atc__hint",
  "atc__loading": "AddToCartButton-module-scss-module__FysyBG__atc__loading",
  "atc__sizer": "AddToCartButton-module-scss-module__FysyBG__atc__sizer",
  "atc__sizer_ghost": "AddToCartButton-module-scss-module__FysyBG__atc__sizer_ghost",
  "atc__sizer_value": "AddToCartButton-module-scss-module__FysyBG__atc__sizer_value",
  "atc__success": "AddToCartButton-module-scss-module__FysyBG__atc__success",
});
